/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ActivateVLRResponse } from '../model/activateVLRResponse';
// @ts-ignore
import { ActivateVLRSpecOperator } from '../model/activateVLRSpecOperator';
// @ts-ignore
import { BuildCertPemValResponse } from '../model/buildCertPemValResponse';
// @ts-ignore
import { CommerceDeactivationOperatorSpec } from '../model/commerceDeactivationOperatorSpec';
// @ts-ignore
import { ComponentHealthResponse } from '../model/componentHealthResponse';
// @ts-ignore
import { DeactivateVLRResponse } from '../model/deactivateVLRResponse';
// @ts-ignore
import { IrrGwCertInstalledData } from '../model/irrGwCertInstalledData';
// @ts-ignore
import { OperatorDetailedVcdsDeployment } from '../model/operatorDetailedVcdsDeployment';
// @ts-ignore
import { OperatorVcdsDeployment } from '../model/operatorVcdsDeployment';
// @ts-ignore
import { OperatorVcdsDeploymentComponent } from '../model/operatorVcdsDeploymentComponent';
// @ts-ignore
import { PaginatedResponse } from '../model/paginatedResponse';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';
// @ts-ignore
import { VcdsCombinedDeploymentDetails } from '../model/vcdsCombinedDeploymentDetails';
// @ts-ignore
import { VcdsDeploymentPatchSpec } from '../model/vcdsDeploymentPatchSpec';
// @ts-ignore
import { VcdsDeploymentToggleLoginPatchSpec } from '../model/vcdsDeploymentToggleLoginPatchSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class InventoryOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * De-activate commerce for VCDS deployments
     * De-activate commerce for VCDS deployments
     * @param commerceDeactivationOperatorSpec Commerce De-activation spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateVcdsCommerceOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<DeactivateVLRResponse>;
    public deactivateVcdsCommerceOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DeactivateVLRResponse>>;
    public deactivateVcdsCommerceOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DeactivateVLRResponse>>;
    public deactivateVcdsCommerceOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (commerceDeactivationOperatorSpec === null || commerceDeactivationOperatorSpec === undefined) {
            throw new Error('Required parameter commerceDeactivationOperatorSpec was null or undefined when calling deactivateVcdsCommerceOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/commerce/deactivate`;
        return this.httpClient.request<DeactivateVLRResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: commerceDeactivationOperatorSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get component health
     * Get component health
     * @param deploymentId Deployment identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComponentHealthOperator(deploymentId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<ComponentHealthResponse>>;
    public getComponentHealthOperator(deploymentId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ComponentHealthResponse>>>;
    public getComponentHealthOperator(deploymentId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ComponentHealthResponse>>>;
    public getComponentHealthOperator(deploymentId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling getComponentHealthOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/components/health`;
        return this.httpClient.request<Array<ComponentHealthResponse>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the certificate for the component type. E.g. IRR Gateway Cert
     * Gets the certificate for the component type. E.g. IRR Gateway Cert
     * @param deploymentId Deployment identifier
     * @param componentType Component type of the deployment.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<IrrGwCertInstalledData>;
    public getDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<IrrGwCertInstalledData>>;
    public getDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<IrrGwCertInstalledData>>;
    public getDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling getDeploymentComponentCertOperator.');
        }
        if (componentType === null || componentType === undefined) {
            throw new Error('Required parameter componentType was null or undefined when calling getDeploymentComponentCertOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>componentType, 'component-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/certs/cert`;
        return this.httpClient.request<IrrGwCertInstalledData>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS detailed deployment
     * Get VCDS detailed deployment
     * @param deploymentId Deployment identifier
     * @param includeDeletedComponents Include deleted components
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDetailedVcdsDeploymentOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorDetailedVcdsDeployment>;
    public getDetailedVcdsDeploymentOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorDetailedVcdsDeployment>>;
    public getDetailedVcdsDeploymentOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorDetailedVcdsDeployment>>;
    public getDetailedVcdsDeploymentOperator(deploymentId: string, includeDeletedComponents?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling getDetailedVcdsDeploymentOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeDeletedComponents, 'include-deleted-components');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<OperatorDetailedVcdsDeployment>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all VCDS deployments including the disconnected deployments.
     * Get all VCDS deployments including the disconnected deployments.
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the deployment entity by this column
     * @param orgId organization identifier in optional filter
     * @param orgName ORG name
     * @param orgType Org Type
     * @param deploymentName Deployment name
     * @param regionId Region ID of Cloud Provider
     * @param availabilityZone Availability zone
     * @param deploymentIsPaired Deployment is paired or not
     * @param releaseVersion Release Version to look for.
     * @param upgradeStatus Upgrade allowed or not
     * @param offlineMode Offline mode
     * @param creationDate created date in YYYY-MM-DD
     * @param lastUpdatedTs last updated date in YYYY-MM-DD
     * @param deploymentIds List of deployment ids
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param state Deployment states
     * @param cloudProvider Cloud provider
     * @param personas Filter deployments by persona. Persona is an array field, so deployments matching any of the provided personas will be returned.
     * @param loginAllowed False if login to product is currently disabled due to subscription issues etc else True.
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsCombinedDeploymentsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'serviceType' | 'vcdsServiceType' | 'orgName' | 'orgType' | 'name' | 'state' | 'provider' | 'releaseVersion' | 'createdTimestamp' | 'updatedTimestamp' | 'deletedTimestamp' | 'reportedTimestamp', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, deploymentIsPaired?: 'true' | 'false', releaseVersion?: string, upgradeStatus?: 'ALLOWED' | 'NOT_ALLOWED' | 'ON_HOLD', offlineMode?: 'true' | 'false', creationDate?: string, lastUpdatedTs?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, cloudProvider?: 'AWS' | 'GCP' | 'ON_PREM', personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, loginAllowed?: boolean, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<VcdsCombinedDeploymentDetails>;
    public getVcdsCombinedDeploymentsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'serviceType' | 'vcdsServiceType' | 'orgName' | 'orgType' | 'name' | 'state' | 'provider' | 'releaseVersion' | 'createdTimestamp' | 'updatedTimestamp' | 'deletedTimestamp' | 'reportedTimestamp', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, deploymentIsPaired?: 'true' | 'false', releaseVersion?: string, upgradeStatus?: 'ALLOWED' | 'NOT_ALLOWED' | 'ON_HOLD', offlineMode?: 'true' | 'false', creationDate?: string, lastUpdatedTs?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, cloudProvider?: 'AWS' | 'GCP' | 'ON_PREM', personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, loginAllowed?: boolean, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VcdsCombinedDeploymentDetails>>;
    public getVcdsCombinedDeploymentsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'serviceType' | 'vcdsServiceType' | 'orgName' | 'orgType' | 'name' | 'state' | 'provider' | 'releaseVersion' | 'createdTimestamp' | 'updatedTimestamp' | 'deletedTimestamp' | 'reportedTimestamp', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, deploymentIsPaired?: 'true' | 'false', releaseVersion?: string, upgradeStatus?: 'ALLOWED' | 'NOT_ALLOWED' | 'ON_HOLD', offlineMode?: 'true' | 'false', creationDate?: string, lastUpdatedTs?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, cloudProvider?: 'AWS' | 'GCP' | 'ON_PREM', personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, loginAllowed?: boolean, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VcdsCombinedDeploymentDetails>>;
    public getVcdsCombinedDeploymentsOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'serviceType' | 'vcdsServiceType' | 'orgName' | 'orgType' | 'name' | 'state' | 'provider' | 'releaseVersion' | 'createdTimestamp' | 'updatedTimestamp' | 'deletedTimestamp' | 'reportedTimestamp', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, deploymentIsPaired?: 'true' | 'false', releaseVersion?: string, upgradeStatus?: 'ALLOWED' | 'NOT_ALLOWED' | 'ON_HOLD', offlineMode?: 'true' | 'false', creationDate?: string, lastUpdatedTs?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, cloudProvider?: 'AWS' | 'GCP' | 'ON_PREM', personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, loginAllowed?: boolean, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getVcdsCombinedDeploymentsOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getVcdsCombinedDeploymentsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgName, 'org-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgType, 'org-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentName, 'deployment-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>availabilityZone, 'availability-zone');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentIsPaired, 'deployment-is-paired');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>upgradeStatus, 'upgrade-status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>offlineMode, 'offline-mode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>creationDate, 'creation-date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>lastUpdatedTs, 'last-updated-ts');
        if (deploymentIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...deploymentIds].join(COLLECTION_FORMATS['csv']), 'deployment-ids');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        if (state) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...state].join(COLLECTION_FORMATS['csv']), 'state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        if (personas) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...personas].join(COLLECTION_FORMATS['csv']), 'personas');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>loginAllowed, 'login-allowed');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/all`;
        return this.httpClient.request<VcdsCombinedDeploymentDetails>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS deployments associated with given componentId
     * Get VCDS deployments associated with given componentId
     * @param componentId Component identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsComponentDeploymentsOperator(componentId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<OperatorVcdsDeployment>>;
    public getVcdsComponentDeploymentsOperator(componentId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<OperatorVcdsDeployment>>>;
    public getVcdsComponentDeploymentsOperator(componentId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<OperatorVcdsDeployment>>>;
    public getVcdsComponentDeploymentsOperator(componentId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (componentId === null || componentId === undefined) {
            throw new Error('Required parameter componentId was null or undefined when calling getVcdsComponentDeploymentsOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/components/${this.configuration.encodeParam({name: "componentId", value: componentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/deployments`;
        return this.httpClient.request<Array<OperatorVcdsDeployment>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS deployment components info
     * Get VCDS deployment components
     * @param deploymentId Deployment identifier
     * @param includeDeletedComponents Include deleted components
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsDeploymentComponentsOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<OperatorVcdsDeploymentComponent>>;
    public getVcdsDeploymentComponentsOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<OperatorVcdsDeploymentComponent>>>;
    public getVcdsDeploymentComponentsOperator(deploymentId: string, includeDeletedComponents?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<OperatorVcdsDeploymentComponent>>>;
    public getVcdsDeploymentComponentsOperator(deploymentId: string, includeDeletedComponents?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling getVcdsDeploymentComponentsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeDeletedComponents, 'include-deleted-components');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/components`;
        return this.httpClient.request<Array<OperatorVcdsDeploymentComponent>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS deployments
     * Get VCDS deployments
     * @param orgId ORG identifier
     * @param deploymentIds List of deployment ids
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param regionId Region ID of Cloud Provider
     * @param gatewayIp Gateway IP of IRR
     * @param releaseVersion Release Version to look for.
     * @param releaseType Release Type
     * @param state Deployment states
     * @param loginAllowed False if login to product is currently disabled due to subscription issues etc else True.
     * @param personas Filter deployments by persona. Persona is an array field, so deployments matching any of the provided personas will be returned.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsDeploymentsOperator(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<OperatorVcdsDeployment>>;
    public getVcdsDeploymentsOperator(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<OperatorVcdsDeployment>>>;
    public getVcdsDeploymentsOperator(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<OperatorVcdsDeployment>>>;
    public getVcdsDeploymentsOperator(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        if (deploymentIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...deploymentIds].join(COLLECTION_FORMATS['csv']), 'deployment-ids');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>gatewayIp, 'gateway-ip');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseType, 'release-type');
        if (state) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...state].join(COLLECTION_FORMATS['csv']), 'state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>loginAllowed, 'login-allowed');
        if (personas) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...personas].join(COLLECTION_FORMATS['csv']), 'personas');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments`;
        return this.httpClient.request<Array<OperatorVcdsDeployment>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get VCDS deployments in a paginated way.
     * Get VCDS deployments in a paginated way.
     * @param orgId ORG identifier
     * @param deploymentIds List of deployment ids
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param regionId Region ID of Cloud Provider
     * @param gatewayIp Gateway IP of IRR
     * @param releaseVersion Release Version to look for.
     * @param releaseType Release Type
     * @param state Deployment states
     * @param loginAllowed False if login to product is currently disabled due to subscription issues etc else True.
     * @param personas Filter deployments by persona. Persona is an array field, so deployments matching any of the provided personas will be returned.
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsDeploymentsOperatorPaginated(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedResponse>;
    public getVcdsDeploymentsOperatorPaginated(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedResponse>>;
    public getVcdsDeploymentsOperatorPaginated(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedResponse>>;
    public getVcdsDeploymentsOperatorPaginated(orgId?: string, deploymentIds?: Array<string>, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', gatewayIp?: string, releaseVersion?: string, releaseType?: 'GA' | 'EA', state?: Array<'DISCOVERED' | 'READY' | 'IN_PROGRESS' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED'>, loginAllowed?: boolean, personas?: Array<'VLCR_CLOUD' | 'VLCR_ONPREM' | 'VLSR' | 'VLSR_MTDR' | 'VMCFS'>, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        if (deploymentIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...deploymentIds].join(COLLECTION_FORMATS['csv']), 'deployment-ids');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>gatewayIp, 'gateway-ip');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseType, 'release-type');
        if (state) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...state].join(COLLECTION_FORMATS['csv']), 'state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>loginAllowed, 'login-allowed');
        if (personas) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...personas].join(COLLECTION_FORMATS['csv']), 'personas');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/paginated`;
        return this.httpClient.request<PaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Build the custom formatted pemVal from the certificate chain and private key.
     * Build the custom formatted pemVal from the certificate chain and private key.
     * @param componentType Component type of the deployment.
     * @param serverCertificate Certificate of the server in pem format.
     * @param intermediaryCertificate Certificate of the intermediary (CA) in pem format.
     * @param rootCertificate Certificate of the root in pem format.
     * @param privateKey Private key file for the server.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public obtainCertPemValOperator(componentType: 'IRR', serverCertificate: Blob, intermediaryCertificate: Blob, rootCertificate: Blob, privateKey: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<BuildCertPemValResponse>;
    public obtainCertPemValOperator(componentType: 'IRR', serverCertificate: Blob, intermediaryCertificate: Blob, rootCertificate: Blob, privateKey: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BuildCertPemValResponse>>;
    public obtainCertPemValOperator(componentType: 'IRR', serverCertificate: Blob, intermediaryCertificate: Blob, rootCertificate: Blob, privateKey: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BuildCertPemValResponse>>;
    public obtainCertPemValOperator(componentType: 'IRR', serverCertificate: Blob, intermediaryCertificate: Blob, rootCertificate: Blob, privateKey: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (componentType === null || componentType === undefined) {
            throw new Error('Required parameter componentType was null or undefined when calling obtainCertPemValOperator.');
        }
        if (serverCertificate === null || serverCertificate === undefined) {
            throw new Error('Required parameter serverCertificate was null or undefined when calling obtainCertPemValOperator.');
        }
        if (intermediaryCertificate === null || intermediaryCertificate === undefined) {
            throw new Error('Required parameter intermediaryCertificate was null or undefined when calling obtainCertPemValOperator.');
        }
        if (rootCertificate === null || rootCertificate === undefined) {
            throw new Error('Required parameter rootCertificate was null or undefined when calling obtainCertPemValOperator.');
        }
        if (privateKey === null || privateKey === undefined) {
            throw new Error('Required parameter privateKey was null or undefined when calling obtainCertPemValOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>componentType, 'component-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (serverCertificate !== undefined) {
            localVarFormParams = localVarFormParams.append('ServerCertificate', <any>serverCertificate) as any || localVarFormParams;
        }
        if (intermediaryCertificate !== undefined) {
            localVarFormParams = localVarFormParams.append('IntermediaryCertificate', <any>intermediaryCertificate) as any || localVarFormParams;
        }
        if (rootCertificate !== undefined) {
            localVarFormParams = localVarFormParams.append('RootCertificate', <any>rootCertificate) as any || localVarFormParams;
        }
        if (privateKey !== undefined) {
            localVarFormParams = localVarFormParams.append('privateKey', <any>privateKey) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/certs/build-cert-pem-val`;
        return this.httpClient.request<BuildCertPemValResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch VCDS deployment
     * Patch VCDS deployment
     * @param deploymentId Deployment identifier
     * @param serviceType Service Type
     * @param vcdsDeploymentPatchSpec VCDS Deployment patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorVcdsDeployment>;
    public patchDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorVcdsDeployment>>;
    public patchDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorVcdsDeployment>>;
    public patchDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling patchDeploymentOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling patchDeploymentOperator.');
        }
        if (vcdsDeploymentPatchSpec === null || vcdsDeploymentPatchSpec === undefined) {
            throw new Error('Required parameter vcdsDeploymentPatchSpec was null or undefined when calling patchDeploymentOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<OperatorVcdsDeployment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vcdsDeploymentPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Probes the live certificate of the deployment and saves the info.
     * Probes the live certificate of the deployment and saves the info.
     * @param deploymentId Deployment identifier
     * @param componentType Component type of the deployment.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public probeDeploymentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public probeDeploymentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public probeDeploymentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public probeDeploymentCertOperator(deploymentId: string, componentType: 'IRR', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling probeDeploymentCertOperator.');
        }
        if (componentType === null || componentType === undefined) {
            throw new Error('Required parameter componentType was null or undefined when calling probeDeploymentCertOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>componentType, 'component-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/certs/probe`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Purge deployments
     * Helper API to purge the deployments. This is for testing and verification purposes only.
     * @param orgId organization identifier
     * @param deploymentId Deployment identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purgeDeploymentsOperator(orgId: string, deploymentId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public purgeDeploymentsOperator(orgId: string, deploymentId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public purgeDeploymentsOperator(orgId: string, deploymentId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public purgeDeploymentsOperator(orgId: string, deploymentId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling purgeDeploymentsOperator.');
        }
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling purgeDeploymentsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/purge`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Register SRM deployment
     * Register SRM deployment
     * @param activateVLRSpecOperator VCDS Deployment register spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public registerSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<ActivateVLRResponse>;
    public registerSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ActivateVLRResponse>>;
    public registerSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ActivateVLRResponse>>;
    public registerSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (activateVLRSpecOperator === null || activateVLRSpecOperator === undefined) {
            throw new Error('Required parameter activateVLRSpecOperator was null or undefined when calling registerSRMDeploymentOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/commerce/activate`;
        return this.httpClient.request<ActivateVLRResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: activateVLRSpecOperator,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch VCDS deployment login allowed flag
     * Patch VCDS deployment login allowed flag to restrict/enable user from logging into product
     * @param deploymentId Deployment identifier
     * @param vcdsDeploymentToggleLoginPatchSpec VCDS Deployment patch spec to toggle login by flipping state of login_allowed flag.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toggleLoginAllowedOperator(deploymentId: string, vcdsDeploymentToggleLoginPatchSpec: VcdsDeploymentToggleLoginPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OperatorVcdsDeployment>;
    public toggleLoginAllowedOperator(deploymentId: string, vcdsDeploymentToggleLoginPatchSpec: VcdsDeploymentToggleLoginPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OperatorVcdsDeployment>>;
    public toggleLoginAllowedOperator(deploymentId: string, vcdsDeploymentToggleLoginPatchSpec: VcdsDeploymentToggleLoginPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OperatorVcdsDeployment>>;
    public toggleLoginAllowedOperator(deploymentId: string, vcdsDeploymentToggleLoginPatchSpec: VcdsDeploymentToggleLoginPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling toggleLoginAllowedOperator.');
        }
        if (vcdsDeploymentToggleLoginPatchSpec === null || vcdsDeploymentToggleLoginPatchSpec === undefined) {
            throw new Error('Required parameter vcdsDeploymentToggleLoginPatchSpec was null or undefined when calling toggleLoginAllowedOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/toggle-login`;
        return this.httpClient.request<OperatorVcdsDeployment>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vcdsDeploymentToggleLoginPatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the certificate for the component type. E.g. IRR Gateway Cert
     * Updates the certificate for the component type. E.g. IRR Gateway Cert
     * @param deploymentId Deployment identifier
     * @param componentType Component type of the deployment.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public updateDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public updateDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public updateDeploymentComponentCertOperator(deploymentId: string, componentType: 'IRR', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling updateDeploymentComponentCertOperator.');
        }
        if (componentType === null || componentType === undefined) {
            throw new Error('Required parameter componentType was null or undefined when calling updateDeploymentComponentCertOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>componentType, 'component-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/certs/update`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the certificate for the component type, and reboots the EC2 instance, considering the component\&#39;s certificate is expired.
     * Updates the certificate for the component type, and reboots the EC2 instance, considering the component\&#39;s certificate is expired.
     * @param deploymentId Deployment identifier
     * @param componentType Component type of the deployment.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDeploymentComponentExpiredCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateDeploymentComponentExpiredCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateDeploymentComponentExpiredCertOperator(deploymentId: string, componentType: 'IRR', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateDeploymentComponentExpiredCertOperator(deploymentId: string, componentType: 'IRR', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling updateDeploymentComponentExpiredCertOperator.');
        }
        if (componentType === null || componentType === undefined) {
            throw new Error('Required parameter componentType was null or undefined when calling updateDeploymentComponentExpiredCertOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>componentType, 'component-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/certs/update-expired`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validate deactivate commerce spec for VCDS deployments
     * Validate deactivate commerce for VCDS deployments
     * @param commerceDeactivationOperatorSpec Commerce De-activation spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateDeactivateCommerceSpecOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public validateDeactivateCommerceSpecOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public validateDeactivateCommerceSpecOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public validateDeactivateCommerceSpecOperator(commerceDeactivationOperatorSpec: CommerceDeactivationOperatorSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (commerceDeactivationOperatorSpec === null || commerceDeactivationOperatorSpec === undefined) {
            throw new Error('Required parameter commerceDeactivationOperatorSpec was null or undefined when calling validateDeactivateCommerceSpecOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/commerce/deactivate/validate`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: commerceDeactivationOperatorSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validate VCDS deployment patch payload
     * Validate VCDS deployment payload
     * @param deploymentId Deployment identifier
     * @param serviceType Service Type
     * @param vcdsDeploymentPatchSpec VCDS Deployment patch spec to be validated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public validateDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public validateDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public validateDeploymentOperator(deploymentId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', vcdsDeploymentPatchSpec: VcdsDeploymentPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deploymentId === null || deploymentId === undefined) {
            throw new Error('Required parameter deploymentId was null or undefined when calling validateDeploymentOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling validateDeploymentOperator.');
        }
        if (vcdsDeploymentPatchSpec === null || vcdsDeploymentPatchSpec === undefined) {
            throw new Error('Required parameter vcdsDeploymentPatchSpec was null or undefined when calling validateDeploymentOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/${this.configuration.encodeParam({name: "deploymentId", value: deploymentId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/validate`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vcdsDeploymentPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validate SRM deployment
     * Validate SRM deployment
     * @param activateVLRSpecOperator VCDS Deployment validate spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public validateSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public validateSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public validateSRMDeploymentOperator(activateVLRSpecOperator: ActivateVLRSpecOperator, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (activateVLRSpecOperator === null || activateVLRSpecOperator === undefined) {
            throw new Error('Required parameter activateVLRSpecOperator was null or undefined when calling validateSRMDeploymentOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/inventory/deployments/commerce/validate`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: activateVLRSpecOperator,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
